// 搬入の正規化応答(CarryIns + related.Materials/Lots/Works/Users/Groups)を、
// 従来のネスト形(carryInRow: 搬入→Materials→Lot、搬入→Work、搬入→User)へ
// 復元する共通ハイドレータ。結合は nestHydrator の宣言的エンジン(生成メタデータのエッジキー)で行う。
// related.Lots / related.Works はサーバー側で alive のみ(従来 include の
// where deleted_at:null を踏襲)のため、削除済みの参照先は従来どおり null になる。
// 工事(Work)は担当者を持たないため User ネストは無い。搬入の User は created_by_user_id で結合する。
// Materials の並びはサーバーのバケット順(id 昇順)をそのまま保つ。
import { carryInRow, NormalizedCarryInResponse } from "../../schema/console/carry_in";
import { belongsToOf, hasManyOf, requiredUserOf } from "./nestHydrator";
import { usersWithGroupOf } from "./relatedLookup";

export function hydrateCarryIns(normalized: NormalizedCarryInResponse): carryInRow[] {
  const related = normalized.related;
  const users = usersWithGroupOf(related.Users, related.Groups);
  const lotOf = belongsToOf("Material.lot_id", related.Lots);
  const workOf = belongsToOf("CarryIn.work_id", related.Works);
  const materialsOf = hasManyOf("CarryIn.Materials", related.Materials);
  const carryInUserOf = requiredUserOf("CarryIn.created_by_user_id", users, "搬入", "登録者");
  return normalized.CarryIns.map((carryIn): carryInRow => ({
    ...carryIn,
    Materials: materialsOf(carryIn.id).map((material) => ({ ...material, Lot: lotOf(material) })),
    Work: workOf(carryIn),
    User: carryInUserOf(carryIn),
  }));
}
